import { FC } from "react";

import { PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from "constants/index";

const Terms: FC = () => (
  <div className="-bottom">
    <div className="-content" style={{ zIndex: 1 }}>
      <p className="text -disclosure -light">
        Use of this website constitutes acceptance of the{" "}
        <a
          href={TERMS_AND_CONDITIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>{" "}
        and{" "}
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        . Designated trademarks and brands are the property of their respective
        owners.
      </p>
      <p className="text -disclosure -light">IMPORTANT DISCLOSURES</p>
      <p className="text -disclosure -light">
        This website (the &quot;Site&quot;) is operated by Royalty Exchange. By
        accessing the Site and any of its pages, you agree to be bound by its{" "}
        <a
          href={TERMS_AND_CONDITIONS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Use
        </a>{" "}
        and{" "}
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        . The Site is maintained for the personal use of its visitors and
        Royalty Exchange cannot guarantee the completeness or accuracy of any
        information presented on any of its pages. Royalty Exchange does not
        make investment recommendations or provide legal, tax, or financial
        advice. No communication should be considered a recommendation of any
        investment opportunity and there can be no assurance that any investment
        valuation is accurate or that any investment opportunity is suitable for
        any particular investor.
      </p>
    </div>
  </div>
);

export default Terms;
